import {
    FixedAssetValueChange,
    FixedAssetsSchedule,
    FixedAssetsScheduleMovement,
} from '@modeso/types__aumico-lib-annualreport-be';
import { omit } from 'lodash-es';
import { FixedAssetFormValueChange } from '../interfaces/fixed-asset-form-value-change.interface';
import { FixedAssetsScheduleFormData } from '../interfaces/fixed-assets-schedule-form-data.interface';
import { FixedAssetsScheduleFormMovement } from '../interfaces/fixed-assets-schedule-form-movement.interface';

export class FixedAssetsScheduleMapper {
    static mapFasFormDataToOutputData(formData: FixedAssetsScheduleFormData): FixedAssetsSchedule | null {
        let fixedAssetsScheduleOutput: FixedAssetsSchedule | null = null;
        if (formData.reference == null) {
            return null;
        }
        fixedAssetsScheduleOutput = {
            reference: formData.reference.reference,
            referenceType: formData.reference.referenceType,
            costsLabel: formData.costsLabel,
            depreciationsLabel: formData.depreciationLabel,
            valueAppreciationLabel: formData.valueAppreciationLabel,
            movements: FixedAssetsScheduleMapper.mapFasFormDataMovementsToOutputMovements(formData.movements),
        };
        return fixedAssetsScheduleOutput;
    }

    private static mapFasFormDataMovementsToOutputMovements(
        formDataMovements: FixedAssetsScheduleFormMovement[],
    ): FixedAssetsScheduleMovement[] {
        const fixedAssetsScheduleMovements: FixedAssetsScheduleMovement[] = [];
        formDataMovements.forEach((formDataMovement) => {
            const fixedAssetsScheduleMovement: FixedAssetsScheduleMovement = {
                name: formDataMovement.name,
                costs: FixedAssetsScheduleMapper.mapFasValueChangeFormDataToOutputValueChange(formDataMovement.costs),
            };

            if (formDataMovement.depreciations !== undefined) {
                fixedAssetsScheduleMovement.depreciations =
                    FixedAssetsScheduleMapper.mapFasValueChangeFormDataToOutputValueChange(
                        formDataMovement.depreciations,
                    );
            }

            if (formDataMovement.valueAppreciations !== undefined) {
                fixedAssetsScheduleMovement.valueAppreciation = formDataMovement.valueAppreciations.openingValue;
            }
            fixedAssetsScheduleMovements.push(fixedAssetsScheduleMovement);
        });
        return fixedAssetsScheduleMovements;
    }

    private static mapFasValueChangeFormDataToOutputValueChange(
        formDataValueChange: FixedAssetFormValueChange,
    ): FixedAssetValueChange {
        return omit<FixedAssetFormValueChange, 'otherValue', 'isValid'>(formDataValueChange, 'otherValue', 'isValid');
    }
}
